<mf-row class="margin-top">
  <mf-grid
    [disableActionButton]="true"
    [hideFilters]="true"
    [columns]="columns"
    [apiEndpoint]="apiEndpoint" />
</mf-row>
